import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    button: {
      margin: [20, 0],
    },
  }),
  { name: "SaveButton" },
);
